import * as React from "react";
import { Theme, styled } from "@mui/material/styles";
import { SxProps } from "@mui/system";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const ProductHeroLayoutAboutRoot = styled("section")(({ theme }) => ({
  color: theme.palette.common.white,
  position: "relative",
  isolation: "isolate",
  display: "flex",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    height: "100vh",
    minHeight: 500,
    maxHeight: 1300,
  },
}));

const Background = styled(Box)({
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  zIndex: 0,
  pointerEvents: "none",
});

interface ProductHeroLayoutAboutProps {
  sxBackground: SxProps<Theme>;
}

export default function ProductHeroLayoutAbout(
  props: React.HTMLAttributes<HTMLDivElement> & ProductHeroLayoutAboutProps
) {
  const { sxBackground, children } = props;

  return (
    <ProductHeroLayoutAboutRoot>
      <Background sx={{ ...sxBackground, zIndex: 0, pointerEvents: "none" }} />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "common.black",
          opacity: 0.5,
          zIndex: 1,
          pointerEvents: "none",
        }}
      />
      <Container
        sx={{
          mt: 5,
          mb: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          position: "relative",
          zIndex: 2,
        }}
      >
        {children}
      </Container>
    </ProductHeroLayoutAboutRoot>
  );
}
